import React from 'react'
import { H2, Ellipsis, Separator, Paragraph, Button } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { useEvent } from '@fs/zion-frontend-friends'
import { deleteGedcomFile } from '@fs/zion-controlled-edit-trees'

export default function GroupCardContentsFailed({ group, refetchGroupList }) {
  const [t] = useTranslation()

  const removeFailedFile = useEvent(() => {
    deleteGedcomFile(group.file.fileName).then(refetchGroupList).catch(console.error)
  })

  const getTranslationKey = (fileStatus, rejectDetail, rejectReason) => {
    switch (true) {
      case rejectDetail && rejectDetail.includes('user group membership limit would be exceeded'):
        return 'group-management.upload-failed-group-limit.label'
      case rejectReason && rejectReason.includes('More than one HEAD record'):
        return 'group-management.upload-failed-too-many-trees-gedcom.label'
      case rejectReason && rejectReason.includes('Missing HEAD record'):
        return 'group-management.upload-failed-not-gedcom.label'
      case fileStatus === 'FAILED_PROCESSING': {
        return 'group-management.processing-failed-unrecognized-format.label'
      }
      case fileStatus === 'FAILED_UPLOAD':
      default:
        return 'group-management.upload-failed-try-again.label'
    }
  }

  return (
    <>
      <H2 size="H6" supplementary>
        <Ellipsis data-testid={`group-title-${group.name}`} lineClamp={2}>
          {group.name}
        </Ellipsis>
      </H2>
      <Separator size="pico" />
      <Paragraph size="sm">
        {t(getTranslationKey(group.file?.fileStatus, group.file?.rejectDetail, group.file?.rejectReason))}
      </Paragraph>
      <Button data-testid="failed-file-dismiss-button" onClick={removeFailedFile}>
        {t('group-management.delete-file.action')}
      </Button>
    </>
  )
}
